export var ESocialsActionTypes;
(function (ESocialsActionTypes) {
  ESocialsActionTypes["Expand"] = "socials/expand";
  ESocialsActionTypes["PhoneChanged"] = "socials/phone/changed";
  ESocialsActionTypes["EmailChanged"] = "socials/email/changed";
})(ESocialsActionTypes || (ESocialsActionTypes = {}));